module.exports = __webpack_public_path__ + "static/media/42.75fde8f1.JPG";